/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { GetUserBaseInfoResponse } from '../models/GetUserBaseInfoResponse';
import type { GetUserDataResponse } from '../models/GetUserDataResponse';
import type { GetUsersResponse } from '../models/GetUsersResponse';
import type { UpdatePasswordRequest } from '../models/UpdatePasswordRequest';
import type { UpdateUserAndRemoveSitesRequest } from '../models/UpdateUserAndRemoveSitesRequest';
import type { UpdateUserAndRemoveSitesResponse } from '../models/UpdateUserAndRemoveSitesResponse';
import type { UpdateUserAndRemoveStudiesRequest } from '../models/UpdateUserAndRemoveStudiesRequest';
import type { UpdateUserAndRemoveStudiesResponse } from '../models/UpdateUserAndRemoveStudiesResponse';
import type { UpdateUserRequest } from '../models/UpdateUserRequest';
import type { UpdateUserResponse } from '../models/UpdateUserResponse';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class UserControllerV2Service {
    constructor(public readonly http: HttpClient) {}
    /**
     * @returns GetUserBaseInfoResponse
     * @throws ApiError
     */
    public userControllerV2GetUserBaseInfo(): Observable<GetUserBaseInfoResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/users/me/base-info',
        });
    }
    /**
     * @returns GetUserDataResponse
     * @throws ApiError
     */
    public userControllerV2GetUserData(): Observable<GetUserDataResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/users/me/userdata',
        });
    }
    /**
     * @returns GetUsersResponse
     * @throws ApiError
     */
    public userControllerV2GetUsers(): Observable<GetUsersResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/users',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns UpdateUserAndRemoveSitesResponse
     * @throws ApiError
     */
    public userControllerV2UpdateUserAndRemoveSites(
        id: number,
        requestBody: UpdateUserAndRemoveSitesRequest,
    ): Observable<UpdateUserAndRemoveSitesResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/v2/users/{id}/remove-sites',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns UpdateUserAndRemoveStudiesResponse
     * @throws ApiError
     */
    public userControllerV2UpdateUserAndRemoveStudies(
        id: number,
        requestBody: UpdateUserAndRemoveStudiesRequest,
    ): Observable<UpdateUserAndRemoveStudiesResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/v2/users/{id}/remove-studies',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns UpdateUserResponse
     * @throws ApiError
     */
    public userControllerV2UpdateUser(
        id: number,
        requestBody: UpdateUserRequest,
    ): Observable<UpdateUserResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/v2/users/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns binary
     * @throws ApiError
     */
    public userControllerV2ResetPassword(
        id: number,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/v2/users/{id}/reset-password',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param userId
     * @returns number
     * @throws ApiError
     */
    public userControllerV2DisableUser(
        userId: number,
    ): Observable<number> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/v2/users/{userId}/disable',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * @returns boolean
     * @throws ApiError
     */
    public userControllerV2HasAccount(): Observable<boolean> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/users/me/hasaccount',
        });
    }
    /**
     * @param requestBody
     * @returns number
     * @throws ApiError
     */
    public userControllerV2UpdatePassword(
        requestBody: UpdatePasswordRequest,
    ): Observable<number> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/v2/users/password',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
